// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ol[type=a] li:before{content:none}ol[type=a] li{list-style-type:lower-alpha}ul[type=a] li:before{content:none}ul[type=a] li{list-style-type:lower-alpha}", ""]);
// Exports
module.exports = exports;
